import { render, staticRenderFns } from "./UserMOUAgreement.vue?vue&type=template&id=25622daf"
import script from "./UserMOUAgreement.vue?vue&type=script&lang=js"
export * from "./UserMOUAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports